export const SET_SELECTED_PRODUCT = 'GUARANTEE_PURCHASES/SET_SELECTED_PRODUCT';
